var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameLogoPoster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.8C1 2.2536 2.2536 1 3.8 1H6.6C8.1464 1 9.4 2.2536 9.4 3.8V6.6C9.4 8.1464 8.1464 9.4 6.6 9.4H3.8C2.2536 9.4 1 8.1464 1 6.6V3.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.8C15 2.2536 16.2536 1 17.8 1H20.6C22.1464 1 23.4 2.2536 23.4 3.8V6.6C23.4 8.1464 22.1464 9.4 20.6 9.4H17.8C16.2536 9.4 15 8.1464 15 6.6V3.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.8C1 16.2536 2.2536 15 3.8 15H6.6C8.1464 15 9.4 16.2536 9.4 17.8V20.6C9.4 22.1464 8.1464 23.4 6.6 23.4H3.8C2.2536 23.4 1 22.1464 1 20.6V17.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.8C15 16.2536 16.2536 15 17.8 15H20.6C22.1464 15 23.4 16.2536 23.4 17.8V20.6C23.4 22.1464 22.1464 23.4 20.6 23.4H17.8C16.2536 23.4 15 22.1464 15 20.6V17.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameLogoPoster);
export default __webpack_public_path__ + "static/media/Game Logo Poster.ee0d30895073e161f9a058697f1ef697.svg";
export { ForwardRef as ReactComponent };